export const aiProviders = [
  {
    id: 1,
    model_provider: 'openai',
    label: 'OpenAI',
  },
  {
    id: 2,
    model_provider: 'gemini',
    label: 'Gemini',
  },
  {
    id: 3,
    model_provider: 'deepseek',
    label: 'DeepSeek',
  },
];

export const headerType = {
  chapter: 'chapter',
  header1: 'header-1',
  header2: 'header-2',
  header3: 'header-3',
};
export const StudentheaderType = {
  chapter: 'chapter',
  header1: 'header-1-clone',
  header2: 'header-2-clone',
  header3: 'header-3-clone',
};

export const contentType = {
  regular: 'REGULAR',
  express: 'EXPRESS',
  custom: 'CUSTOM',
};

export const monthArray = [
  { label: 'January', value: 1 },
  { label: 'February', value: 2 },
  { label: 'March', value: 3 },
  { label: 'April', value: 4 },
  { label: 'May', value: 5 },
  { label: 'June', value: 6 },
  { label: 'July', value: 7 },
  { label: 'August', value: 8 },
  { label: 'September', value: 9 },
  { label: 'October', value: 10 },
  { label: 'November', value: 11 },
  { label: 'December', value: 12 },
];

export const pageURL = {
  systemURL: process.env.REACT_APP_API_IMAGEURL,
  // systemURL: 'http://localhost:3000',
  // systemURL: 'http://192.168.1.152:3001'
};

export const renderTypeObj = {
  'book-detail': 'author',
  'instructor-detail': 'instructor',
  'student-detail': 'student',
  'reader-detail': 'reader',
};

export const breadCrumArray = [
  {
    title: 'Home',
    url: '/',
    is_enable: true,
  },
  {
    title: 'Library',
    url: '/library',
    is_enable: true,
  },
  {
    title: 'Book Name',
    url: '/book/book-name',
    is_enable: true,
  },
  {
    title: 'Chapter Name',
    url: '/book/book-name/chapter-name',
    is_enable: true,
  },
  {
    title: 'Header 1 Name',
    url: '/book/book-name/chapter-name/header-1-name',
    is_enable: false,
  },
];

export const bookType = {
  main: 'main',
  clone: 'clone',
};
export const roleType = {
  AUTHOR: 'AUTHOR',
  INSTRUCTOR: 'INSTRUCTOR',
  READER: 'READER',
  PUBLIC: 'PUBLIC',
  STUDENT: 'STUDENT',
};

// export const breadHelperFunction =
